import BaseDataService from "./BaseDataService";
import http from "../http-common";


class FilterDataService extends BaseDataService {
  constructor(name) {
    super(name)
    this.moduleName = 'apis/dropdowns/clients'
  }

  search(payload) {
    return http.get(`/${this.moduleName}`, { params: payload });
  }
}

export default new FilterDataService();